// DO NOT EDIT THIS FILE UNLESS YOU KNOW WHAT YOU ARE DOING
  // This file was either generated during yarn prepare or build
  // TRANSLATION HASH = "master" will provide the translations for the latest merge to master
  // TRANSLATION HASH = "hash..." will provide the translations for a specific build
  // In most cases you will want "master" for local development
  
  const TRANSLATION_BUNDLE_NAME = "4cad6783fb1a18aae2543e65bc0f060392f32d25c71a8790ee8ec1c959c347f4";
  
  export { TRANSLATION_BUNDLE_NAME };
  